import api from '@/api/api_telegram'
import Vue from 'vue'
import { asyncLoading } from 'vuejs-loading-plugin'
import VueLoading from 'vuejs-loading-plugin'


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Carregando', // default 'Loading'
    loading: false, // default false
    background: 'rgba(10,23,55,0.7)', // set custom background
})

export default {
  TESTETELEGRAM ({ commit }, {codigoTelegram}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.testetelegram(codigoTelegram)
        commit("TESTETELEGRAM", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  BUSCATELEGRAM ({ commit }, {codigoUsuario, cidade}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscatelegram(codigoUsuario, cidade)
        commit("BUSCATELEGRAM", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  GRAVATELEGRAM ({ commit }, {codigoUsuario, codigoTelegram, cidade}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.gravatelegram(codigoUsuario, codigoTelegram, cidade)
        commit("GRAVATELEGRAM", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
}